import type { InfiniteData } from '@reduxjs/toolkit/query';

import type { CursorPaginatedEntityResponse } from '@models';

/**
 * Extracts and flattens items from cursor-paginated infinite query data.
 * Reusable across all search API endpoints that return
 * `CursorPaginatedEntityResponse`.
 */
export const extractSearchPages = <T>(
  queryData:
    InfiniteData<CursorPaginatedEntityResponse<T[]>, string | null> | undefined,
) => queryData?.pages.flatMap(({ data }) => data) ?? [];
